var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ayuda-tema-base',{attrs:{"busqueda":_vm.busqueda,"color":_vm.color,"faqs":_vm.faqs,"video-url":"https://share.synthesia.io/embeds/videos/908357a4-6c14-4eec-9ee1-c64565b9a452","video-titulo":"Visión general del Centro de Reservas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }